export default __webpack_public_path__ + "static/media/tich_hop_firm_bank_vn.50416c89.png";